import { useContext } from 'react';
import type { FeatureResult, JSONValue } from '@growthbook/growthbook';
import { GrowthBookContext } from '@growthbook/growthbook-react';

import type { GrowthbookFlag } from '../constants/feature-flags';

export const useFeatureFlagIsOn = (featureFlag: GrowthbookFlag) => {
  const { growthbook } = useContext(GrowthBookContext);
  if (!growthbook) {
    return false;
  }

  return growthbook.isOn(featureFlag);
};

export const useFeatureFlagValue = <T extends JSONValue = any>(
  featureFlag: GrowthbookFlag,
  defaultValue: T
) => {
  const { growthbook } = useContext(GrowthBookContext);
  if (!growthbook) {
    return defaultValue;
  }

  return growthbook.getFeatureValue(featureFlag, defaultValue);
};

export const useFeatureFlagResult = (featureFlag: string, defaultValue: string): FeatureResult => {
  const { growthbook } = useContext(GrowthBookContext);
  const defaultObject: FeatureResult<string> = {
    value: defaultValue,
    source: 'defaultValue',
    on: false,
    off: false,
    ruleId: '',
  };
  if (!growthbook) {
    return defaultObject;
  }

  const result = growthbook.evalFeature(featureFlag);
  if (!result || !result.value) {
    return defaultObject;
  }

  return result;
};
